export default __webpack_public_path__ + "static/media/organization2-white.d23df166.svg";